export default {
  SET_DOING_ITEMS(state, value) {
    state.doingItems = value;
  },
  ADD_DOING_ITEMS(state, value) {
    state.doingItems.push(value);
  },
  ADD_DOING_ITEMS_AT_ONCE(state, value) {
    state.doingItems = value;
  },
  UPDATE_DOING_ITEMS(state, value) {
    state.doingItems[value.index].status = value.status;
  },
  REMOVE_DOING_ITEMS(state, value) {
    state.doingItems.pop(value);
  },
  ADD_DISTRIBUTED_ITEMS(state, value) {
    state.distributedItems = value;
  },
};
